import React, { useState,useEffect } from "react";
import LineChart from "./LineChart";
import "./TarjetaPresion.css"; // Importa el CSS

const TarjetaPresion = ({ imagen, presion1, task,titulo,last}) => {

  const [presion2, setPresion2] = useState("—");
  const [delay, setDelay] = useState("—");
  const [delaySec, setdelaySec] = useState(1000);

  const [DS, setDS] = useState(null);

  /**************************************************
   * 
   *  24-07-2055
   *  es el div completo que es contenedor de la imagen 
   *  de referencia del acumulador, la presión detenido,
   *  la presión actual y el gráfico de línea 
   *
   * 
   ***************************************************/


  const handleLastValues = (presion, delay,task,DS,delaySec) => {
    setPresion2(presion);
    setDelay(delay);
    setdelaySec(delaySec);
    //setTask(task);
    setDS(DS);
  };

  const lastPressure = presion1;


   /*----------------------------------*/


  const timestampSec = Math.floor(Date.now() / 1000); // Ej: 1721929945
  let lastRes = timestampSec-last
  let lasData = lastRes

  if(lastRes>60 && lastRes<3600){
    lastRes = Math.round(lastRes/60) + ' min'
  }
  else if(lastRes>=3600 && lastRes < 86400){
    lastRes = Math.round(lastRes/3600) + ' hrs'
  }
  else if(lastRes >= 86400){
    lastRes = Math.round(lastRes/86400) + ' dias'
  }
  else{
    lastRes = Math.round(lastRes) + ' seg'
  }

  /*----------------------------------------*/

  //const engineImg = (DS > 60 && delaySec < 120)? '../img/engine_running.png' : '../img/engine_stopped.png';
  const engineImg = (DS > 60 && delaySec < 120)? 'img/engine_running.png' : 'img/engine_stopped.png';
  const engineClass = (DS > 60 && delaySec < 120) ? 'engine-blink' : '';
/*
  console.log(DS)
  console.log(delaySec)
  console.log("")
*/
  const freno_clase = (task == 'freno_1' || task == 'freno_2' ||task == 'freno_3' ||task == 'freno_4')? 'fren-bck':'';

  return (

    <div className={`tarjeta-presion-grid ${freno_clase}`}>
      <div className="icono-superior-derecha">
        <img src={engineImg} alt="engine" className={engineClass} />
      </div>
    

      {/* Columna 0 */}
      <div className="col col0">{(task.split('_')[1])}</div>


    
      {/* Columna 1 */}
      <div className="col col1">
        
        {/*<img src={imagen || "../../src/img/default-image.jpg"} alt="imagen" />*/}

        <img
          src={imagen}
          alt="imagen"
          onError={(e) => {
            e.target.onerror = null; // evita bucle infinito si default también falla
            //e.target.src = "../img/default-image-2.jpg";
            e.target.src = "img/default-image-2.jpg";
          }}
        />
        
        {/*<small className="text">{titulo}</small>*/}
      </div>

      {/* Título que abarca col2 y col3 arriba */}
      <div className="titulo-grid">PRESION DE NITROGENO</div>

      {/* Columna 2 abajo */}
      <div className="col col2">
        <div><small>ULTIMA VEZ DETENIDO</small></div>
        <div className="p1">{lastPressure}</div>
        <div><small>PSI</small></div>
        <div><small>Hace {lastRes}</small></div>
      </div>

      {/* Columna 3 abajo */}
      <div className="col col3">
        <div><small style={{color:"#ff9900", opacity:"0.5"}}>ULTIMA LECTURA</small></div>
        <div className="p2">{presion2}</div>
        
        <div><small style={{color:"#ff9900", opacity:"0.4"}}>PSI</small></div>

        <div className="delay"><small>Hace {delay}</small></div>
        <div className="delay"><small>{task}</small></div>

      </div>

    {/* Columna 4 */}
    <div className='col col4'>
      <LineChart task={task} onLastValueChange={handleLastValues} />
    </div>

  </div>

  );
};

export default TarjetaPresion;
